"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLoading = exports.withSkeletonLoading = void 0;
/* eslint-disable react/display-name */
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const spin_1 = __importDefault(require("antd/lib/spin"));
// eslint-disable-next-line @typescript-eslint/ban-types
const withSkeletonLoading = (Component) => ({ isLoading, wrapperStyle, ...props }) => isLoading ? (react_1.default.createElement("div", { style: wrapperStyle },
    react_1.default.createElement(antd_1.Skeleton, { active: true, round: true }))) : (react_1.default.createElement(Component, { ...props }));
exports.withSkeletonLoading = withSkeletonLoading;
// eslint-disable-next-line @typescript-eslint/ban-types
const withLoading = (Component) => ({ isLoading, wrapperStyle, indicator, ...props }) => (react_1.default.createElement("div", { style: wrapperStyle },
    react_1.default.createElement(spin_1.default, { spinning: isLoading, indicator: indicator },
        react_1.default.createElement(Component, { ...props }))));
exports.withLoading = withLoading;
